import { createIcon } from './createIcon'

export const FilterIcon = createIcon({
  displayName: 'FilterIcon',
  viewBox: '0 0 22 12',
  path: [
    <line y1="1" x2="22.5" y2="1" stroke="currentColor" strokeWidth="1.8" />,
    <line
      x1="5.83337"
      y1="6"
      x2="17.5"
      y2="6"
      stroke="currentColor"
      strokeWidth="1.8"
    />,
    <line
      x1="8.33337"
      y1="11"
      x2="14.1667"
      y2="11"
      stroke="currentColor"
      strokeWidth="1.8"
    />,
  ],
})
